// Third Party Library
import {
  Badge,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  message,
  Upload,
  Typography,
  Image,
} from "antd";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DeleteOutlined, LockOutlined } from "@ant-design/icons";

// Constant Library
import { ICON } from "../../../../../../constants/img";
import { ROOT_CONSTANT, TEMPLATE } from "../../../../constants";

// Components Library
import { BtnSubmit, ButtonLink } from "../../../../components";

import { uploadHDLR } from "../../../../handlers";

import * as REDUX_ACTION from "../../../../services/redux/actions";

import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util";

// Styles Library
import "./index.css";

const { getBase64, UploadReceiptAttachment } = uploadHDLR;

const { reduxStoreWrapper } = REDUX_UTIL;

const { convertTimeFormat, parseDate, parseTimeMin } = TIME;

const { BILLING_STATUS_TITLE } = TEMPLATE.BILLING;
const { icon_bank_rhb } = ROOT_CONSTANT.IMG.ICON.BANK;
const { icon_receipt } = ICON;

const { Text } = Typography;

const DrawerBilling = (props) => {
  const { isOpen, setIsOpen, form, handleSave, data, type, fileList, setFileList, edit, setEdit } = props;


  const user = useSelector(reduxStoreWrapper("user"));

  const { name, colorTag, bgColor } = BILLING_STATUS_TITLE[data?.status || 4];
  const [text, setText] = useState(null);

  const { billing_period, due_date, createdAt } = data;

  const formatPeriod = (start, end) => {
    const format = (date) => date ? convertTimeFormat(date) : " ";
    return `${format(start)} - ${format(end)}`;
  };
  
  const period = formatPeriod(billing_period?.start, billing_period?.end);
  const isAdmin = user?.uroleid === "A";
  const amount = data?.amount || 0;
  const myrCurr = amount.toLocaleString("ms-MY", {
    style: "currency",
    currency: "MYR",
    maximumFractionDigits: 0,
  });

  useEffect(() => {
    if (isOpen) {
      const dataFile = data?.receipt?.map((d, index) => {
        return {
          uid: index,
          name: d.name,
          status: 'done',
          url: d.url,
          refid: d.refid || "RF001",
        };
      });
      setFileList(dataFile || []);
    }
  }, [isOpen, data]);

  const validateFileType = (file) => {
    const fileTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    return fileTypes.includes(file.type);
  };

  const handleBeforeUpload = (file) => {
    if (!validateFileType(file)) {
      message.error(`File type ${file.type} is not supported.`);
      return false;
    }
    // else if (fileList.length >= 3) {
    //   message.error("You can only upload up to 3 files.");
    //   return false;
    // }
    else if (text === null) {
      message.error("Input the Reference ID");
      return false;
    } else {
      return true;
    }
  };

  const handleChangeUpload = (info) => {
    const { status, originFileObj, response = {}, name } = info.file;

    if (status === "uploading") {
      return;
    }
    if (status === "done") {
      getBase64(originFileObj, () => {
        const { Location: url } = response;
        setFileList((prev) => [
          ...prev,
          { url: url, name: `${text} (${name})`, refid: text,  uid: (prev.length > 0 ? Number(prev[prev.length - 1].uid) + 1 : 1), status: 'done' },
        ]);
        setText(null);
        type === "update" && setEdit(true);
        form.setFieldValue("refid", null);
      });
    }
  };

  const handleRemove = (file) => {
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
    setEdit(true);
  };

  const ActionButton = (
    <Form.Item style={{ paddingTop: "20px" }}>
      <div>
        <BtnSubmit
          display="inline-block"
          text={type === "update" || type === "view2" ? "Close" : "Pay"}
          bgColor="#506DEE"
          color="white"
          padding="9px 18px"
          width={type === "pay" ? "170px" : "350px"}
          disable={type === "view"}
          onClick={() => {
            type === "pay" && handleSave();
            setIsOpen(false);
            form.resetFields();
          }}
        />
        {type === "pay" && (
          <BtnSubmit
            display="inline-block"
            text="Cancel"
            bgColor="transparent"
            color="#c8c8c8"
            padding="9px 18px"
            border="1px solid #c8c8c8"
            width="170px"
            onClick={() => {setIsOpen(false); form.resetFields();}}
          />
        )}
      </div>
    </Form.Item>
  );

  const ManageReceipt = (
    <>
      <Row>
        <Col style={{ width: "100%" }}>
          <label htmlFor="refid" className="labelInput">
            Receipt Reference <span style={{ color: "red" }}>*</span>
          </label>
          <Form.Item name="refid">
            <Input
              style={{ width: "22.3rem", padding: ".6rem 10px", left: "6px" }}
              onChange={(e) => setText(e.target.value)}
              readOnly={type === "view" || type === "view2"}
              suffix={
                text !== null ? (
                  <Upload
                    beforeUpload={handleBeforeUpload}
                    onChange={handleChangeUpload}
                    customRequest={UploadReceiptAttachment}
                  >
                    <ButtonLink>Upload</ButtonLink>
                  </Upload>
                ) : (
                  <Text color="gray">Upload</Text>
                )
              }
            />
          </Form.Item>
        </Col>
      </Row>
      {fileList.length > 0 && (
        <Upload
          listType="picture"
          fileList={fileList}
          onRemove={(data) => handleRemove(data)}>
        </Upload>
      )}
    </>
  );

  return (
    <>
      <Drawer
        title={
          type === "pay"
            ? "Pay Bill"
            : type === "update" || type === "view2"
            ? "Manage Receipt"
            : type === "view"
            ? "View Bill"
            : ""
        }
        open={isOpen}
        onClose={() => {
          form.resetFields();
          setFileList([]);
          setIsOpen(false);
        }}
        width={410}
        style={{
          textAlign: "center",
          fontSize: "15px",
        }}
        footer={ActionButton}
      >
        <Form form={form} layout="vertical">
          {!isAdmin && (type === "pay" || "view") && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <Row>
                    <Col style={{ marginBottom: "5px" }}>
                      <span className="semi-bold">Billing Amount</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span style={{ fontSize: "24px", fontWeight: "500" }}>
                        {myrCurr}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ marginBottom: "5px" }}>
                      <span style={{ color: "#a2a2a2" }}>
                        Generated at {parseTimeMin(createdAt)}
                      </span>
                    </Col>
                  </Row>
                </div>
                <img
                  src={icon_receipt}
                  alt=""
                  style={{ marginRight: "20px" }}
                />
              </div>
              <hr />
              <Row className="row-list">
                <Col className="paybill-list">Status</Col>
                <Col>
                  <div
                    style={{
                      backgroundColor: bgColor,
                      borderRadius: "30px",
                      display: "inline-block",
                      padding: "3px 13px",
                    }}
                  >
                    <Badge
                      color={colorTag}
                      text={<span style={{ color: colorTag }}>{name}</span>}
                      className="semi-bold"
                    ></Badge>
                  </div>
                </Col>
              </Row>
              <Row className="row-list">
                <Col className="paybill-list">Billing Period</Col>
                <Col className="semi-bold">{period}</Col>
              </Row>
              <Row className="row-list">
                <Col className="paybill-list">Due At</Col>
                <Col className="semi-bold">{parseDate(due_date)}</Col>
              </Row>
              <hr />
              <Row className="row-list">
                <Col className="paybill-list">Recipient</Col>
                <Col className="semi-bold">Beta Lab Sdn Bhd</Col>
              </Row>
              <Row className="row-list">
                <Col className="paybill-list">Bank</Col>
                <Row>
                  <Col>
                    <Image src={icon_bank_rhb} alt="rhb" className="rhb-icon" />
                  </Col>
                  <Col className="semi-bold" style={{ marginLeft: "5px" }}>
                    RHB Bank
                  </Col>
                </Row>
              </Row>
              <Row className="row-list">
                <Col className="paybill-list">Bank Number</Col>
                <Col className="semi-bold">21444 6000 78397</Col>
              </Row>
              <hr />
              <Row style={{ marginTop: "40px" }}>
                <Col style={{ width: "100%", marginBottom: "10px" }}>
                  <label htmlFor="amount" className="labelInput">
                    Amount
                  </label>
                  <Form.Item name="amount" dependencies={["amount"]}>
                    <Input
                      className="inputForm"
                      readOnly
                      suffix={<LockOutlined style={{ color: "#d9d9d9" }} />}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {ManageReceipt}
            </div>
          )}
          {isAdmin && ManageReceipt}
        </Form>
      </Drawer>
    </>
  );
};

export default DrawerBilling;